import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

const Dstillery = () => {
  return (
    <ProjectLayout
      title="Dstillery"
      description={[
        'I worked with Dstillery to create a logo animation that aligned with their expertise in AI-powered programmatic advertising.',
        'The animation focused on clean, purposeful motion that brings their logo to life, reinforcing their commitment to precision and data-driven insights.',
      ]}
      credits={['Logo Animation', 'Motion Design']}
    >
      <div className="pm-video">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="/images/dstillery-logo-animation-poster.jpg"
        >
          <source src="/videos/dstillery-logo-animation.mp4" type="video/mp4" />
        </video>
      </div>
    </ProjectLayout>
  );
};

export default Dstillery;
